import React from "react";
import ReactDOM from "react-dom";
import "./styles/styles.css";
import "./index.css";
import AppProviders from "./context/AppProviders";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import log from "loglevel";

if (process.env.NODE_ENV === "development") {
  log.setDefaultLevel("debug");
} else {
  log.disableAll();
}

ReactDOM.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
